import { render, staticRenderFns } from "./200.vue?vue&type=template&id=071b30da&scoped=true&"
var script = {}
import style0 from "./200.vue?vue&type=style&index=0&id=071b30da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b30da",
  null
  
)

export default component.exports